// The Light Room Home, sections de la maquette (style C).
(() => {
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  // Au changement de variante, le thème fait scrollIntoView() sur la photo de la variante :
  // prévu pour une galerie empilée, il fait sauter toute la page avec notre carrousel.
  // Pour une photo du carrousel, on fait seulement défiler le carrousel, pas la page.
  const nativeSIV = Element.prototype.scrollIntoView;
  Element.prototype.scrollIntoView = function (opts) {
    if (this.matches && this.matches('.product-information media-gallery slideshow-slide')) {
      const track = this.parentElement;
      if (track) track.scrollTo({ left: this.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      return;
    }
    return nativeSIV.apply(this, arguments);
  };
  function init() {
    // bandeau d'annonce : l'en-tête colle juste sous lui
    const ann = document.querySelector('.tlr-hdr .ann');
    if (ann) document.documentElement.style.setProperty('--tlr-ann', ann.offsetHeight + 'px');
    // bandeau d'annonce : les messages défilent toutes les 4 secondes
    const an = document.querySelector('[data-tlr-ann]');
    if (an && !an.dataset.ok) {
      an.dataset.ok = 1;
      const ms = $$('.ann__m', an);
      if (ms.length > 1) { let i = 0; setInterval(() => { ms[i].classList.remove('is-on'); ms[i].classList.add('is-out');
        const o = ms[i]; setTimeout(() => o.classList.remove('is-out'), 600); i = (i + 1) % ms.length; ms[i].classList.add('is-on'); }, 4000); }
    }
    // menu mobile
    const dr = document.querySelector('[data-tlr-drawer]'), bu = document.querySelector('[data-tlr-burger]');
    if (dr && bu && !bu.dataset.ok) {
      bu.dataset.ok = 1;
      bu.onclick = () => { dr.hidden = false; bu.setAttribute('aria-expanded', 'true'); };
      dr.onclick = e => { if (e.target === dr || e.target.closest('[data-tlr-close]')) { dr.hidden = true; bu.setAttribute('aria-expanded', 'false'); } };
    }
    // interrupteur des Bestsellers : toutes les lampes s'allument d'un coup
    $$('[data-tlr-switch]').forEach(b => {
      if (b.dataset.ok) return; b.dataset.ok = 1;
      const grid = b.closest('section').querySelector('.lightup');
      b.onclick = () => {
        const on = b.getAttribute('aria-checked') !== 'true';
        b.setAttribute('aria-checked', on); b.querySelector('.sl').textContent = on ? 'Lights on' : 'Turn the lights on';
        grid && grid.classList.toggle('on', on);
      };
    });
    // Shop the room : le point et la ligne du même produit s'éclairent ensemble
    $$('.room').forEach(r => $$('.hs,.ri', r).forEach(el => {
      if (el.dataset.ok) return; el.dataset.ok = 1;
      const sync = on => $$('[data-k="' + el.dataset.k + '"]', r).forEach(x => x.classList.toggle('hl', on));
      el.addEventListener('mouseenter', () => sync(true)); el.addEventListener('mouseleave', () => sync(false));
    }));
    // texte de collection replié
    $$('[data-tlr-more]').forEach(b => {
      if (b.dataset.ok) return; b.dataset.ok = 1;
      const t = document.getElementById(b.dataset.tlrMore), more = b.dataset.more || 'Read more', less = b.dataset.less || 'Read less';
      // le bouton n'apparaît que si le texte dépasse vraiment
      if (b.hidden) b.hidden = t.scrollHeight <= t.clientHeight + 2;
      b.onclick = () => { t.classList.toggle('open'); b.textContent = t.classList.contains('open') ? less : more; };
    });
  }
  // fiche produit : « Buy it now » passe par le vrai formulaire du thème, puis la caisse
  function product() {
    const form = document.querySelector('.product-details form[action*="/cart/add"]');
    const bn = document.querySelector('[data-tlr-buynow]');
    if (form && bn && !bn.dataset.ok) {
      bn.dataset.ok = 1;
      bn.onclick = () => {
        let r = form.querySelector('input[name="return_to"]');
        if (!r) { r = document.createElement('input'); r.type = 'hidden'; r.name = 'return_to'; form.appendChild(r); }
        r.value = '/checkout';
        HTMLFormElement.prototype.submit.call(form);
      };
    }
    // Klarna : trois fois le total affiché sur le bouton (il suit le Value set)
    const add = document.querySelector('.product-details .add-to-cart-button'), kl = document.querySelector('[data-tlr-kl]');
    if (add && kl && !kl.dataset.ok) {
      kl.dataset.ok = 1;
      const cur = kl.dataset.cur || '£';
      const upd = () => { const m = add.textContent.replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
        if (m) kl.textContent = cur + (Math.ceil(parseFloat(m[1]) / 3 * 100) / 100).toFixed(2); };
      upd(); new MutationObserver(upd).observe(add, { childList: true, subtree: true, characterData: true });
    }
    // galerie : compteur « 2 / 12 » qui suit la vignette sélectionnée
    const mg = document.querySelector('.product-information media-gallery');
    if (mg && !mg.querySelector('.tlr-cnt')) {
      const th = $$('.slideshow-controls__thumbnail', mg);
      if (th.length > 1) {
        const c = document.createElement('span'); c.className = 'tlr-cnt';
        const host = mg.querySelector('slideshow-container') || mg; host.style.position = 'relative'; host.appendChild(c);
        const upd = () => { const i = th.findIndex(t => t.getAttribute('aria-selected') === 'true'); c.textContent = (i < 0 ? 1 : i + 1) + ' / ' + th.length; };
        upd(); th.forEach(t => new MutationObserver(upd).observe(t, { attributes: true, attributeFilter: ['aria-selected'] }));
      }
    }
    // ordinateur : les menus déroulants et le contact passent sous la photo (sinon un grand vide
    // sous la galerie) ; sur mobile ils reviennent à leur place dans la fiche
    const media = document.querySelector('.product-information__media');
    const acc = document.querySelector('.product-details [class*="tle-acc-"]');
    if (media && acc && !media.dataset.tlrMove) {
      media.dataset.tlrMove = 1;
      const accWrap = acc.closest('.product-details .group-block-content > *') || acc;
      const contact = document.querySelector('.product-details .tle-contact');
      const contactWrap = contact && (contact.closest('.product-details .group-block-content > *') || contact);
      const comp = document.querySelector('.product-details [data-tlr-complete]');
      const compWrap = comp && (comp.closest('.product-details .group-block-content > *') || comp);
      const parts = [accWrap, contactWrap, compWrap].filter(Boolean).map(el => ({ el, mark: el.parentNode.insertBefore(document.createComment('tlr'), el) }));
      const box = document.createElement('div'); box.className = 'tlr-under-media';
      const mq = matchMedia('(min-width: 750px)');
      const place = () => {
        if (mq.matches) { parts.forEach(p => box.appendChild(p.el)); if (!box.parentNode) media.appendChild(box); }
        else { parts.forEach(p => p.mark.parentNode.insertBefore(p.el, p.mark.nextSibling)); box.remove(); }
      };
      place(); mq.addEventListener('change', place);
    }
    // ordinateur : les cartes de réassurance remplissent le vide sous la colonne produit (2 x 2)
    const rs = document.querySelector('[id*="__tlr_reassure"] .tlr-c'), pd = document.querySelector('.product-information .product-details');
    if (rs && pd && !rs.dataset.tlrMove) {
      rs.dataset.tlrMove = 1;
      const home = rs.parentNode, mq2 = matchMedia('(min-width: 990px)');
      const col = pd; // à côté de la carte blanche, pas dedans : des bulles séparées juste dessous
      const put = () => { if (mq2.matches) { col.appendChild(rs); rs.classList.add('tlr-rs-side'); } else { home.appendChild(rs); rs.classList.remove('tlr-rs-side'); } };
      put(); mq2.addEventListener('change', put);
    }
    // formulaire de devis : envoi sans recharger la page ; si Shopify demande une vérification, envoi classique
    const quote = document.getElementById('tlr-quote');
    if (quote && !quote.dataset.tlrAjax) {
      quote.dataset.tlrAjax = 1;
      quote.addEventListener('submit', async e => {
        if (quote.dataset.native) return;
        e.preventDefault();
        const btn = quote.querySelector('[type=submit]'); btn.disabled = true; btn.textContent = 'Sending…';
        try {
          const res = await fetch(quote.action.split('#')[0], { method: 'POST', body: new FormData(quote) });
          if (/contact_posted=true/.test(res.url)) {
            quote.innerHTML = '<p class="tlr-trade__ok" role="status">Thank you, your request is with us. We will come back to you by email with a quote.</p>';
            return;
          }
        } catch (err) {}
        quote.dataset.native = 1; HTMLFormElement.prototype.submit.call(quote);
      });
      // retour d'un envoi classique : le bloc vient d'être déplacé, on y revient sans saut
      if (/contact_posted|tlr-quote/.test(location.search + location.hash)) [60, 600].forEach(ms => setTimeout(() => window.scrollTo(0, quote.getBoundingClientRect().top + scrollY - innerHeight / 3), ms));
    }
  }
  // cross-sell à cocher : total en direct, un bouton ajoute la sélection au panier
  function crossSell() {
    $$('[data-tlr-complete]').forEach(box => {
      if (box.dataset.ok) return; box.dataset.ok = 1;
      const items = $$('[data-cs]', box), tot = box.querySelector('[data-cs-total]'), add = box.querySelector('[data-cs-add]'), ok = box.querySelector('[data-cs-ok]');
      const fmt = c => '£' + (c / 100).toFixed(2);
      const sel = it => { const v = it.querySelector('[data-cs-v]'); return { id: +v.value, price: +v.dataset.price }; };
      const upd = () => {
        let sum = 0, k = 0;
        items.forEach(it => { const s = sel(it); it.querySelector('[data-cs-price]').textContent = fmt(s.price);
          if (it.querySelector('[data-cs-ck]').checked) { sum += s.price; k++; } });
        tot.textContent = fmt(sum); add.disabled = !k;
        add.textContent = k ? 'Add ' + (k === 1 ? 'it' : k === items.length ? 'all ' + k : k) + ' to basket' : 'Select a piece';
      };
      items.forEach(it => {
        it.addEventListener('change', upd);
        // pastille : change la variante, le prix et la photo, et coche le produit
        $$('[data-cs-sw]', it).forEach(b => b.addEventListener('click', e => {
          e.preventDefault(); e.stopPropagation();
          const v = it.querySelector('[data-cs-v]'); v.value = b.dataset.id; v.dataset.price = b.dataset.price;
          $$('[data-cs-sw]', it).forEach(x => x.classList.toggle('on', x === b));
          const img = it.querySelector('.tlr-complete__im img');
          if (img && b.dataset.img) { img.removeAttribute('srcset'); img.src = b.dataset.img; }
          it.querySelector('[data-cs-ck]').checked = true; upd();
        }));
      });
      add.addEventListener('click', async () => {
        const list = items.filter(it => it.querySelector('[data-cs-ck]').checked).map(it => ({ id: sel(it).id, quantity: 1 }));
        if (!list.length) return;
        add.disabled = true; add.textContent = 'Adding…';
        try {
          const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: list }) });
          if (!r.ok) throw 0;
          const cart = await (await fetch('/cart.js')).json();
          $$('[data-tlr-count]').forEach(x => x.textContent = cart.item_count);
          ok.hidden = false; add.textContent = 'Added';
          setTimeout(upd, 2500);
        } catch (e) { add.textContent = 'Try again'; add.disabled = false; }
      });
      upd();
    });
  }
  // collection : un seul menu de filtre ouvert à la fois, fermé au clic dehors ;
  // « Load more » ajoute la page suivante sous la grille
  function collection() {
    const hd = document.querySelector('.tlr-hdr .hd');
    if (hd) document.documentElement.style.setProperty('--tlr-hd', (hd.offsetHeight + 16) + 'px');
    $$('.tlr-dd').forEach(d => {
      if (d.dataset.ok) return; d.dataset.ok = 1;
      d.addEventListener('toggle', () => { if (d.open) $$('.tlr-dd[open]').forEach(o => o !== d && (o.open = false)); });
    });
    if (!document.documentElement.dataset.tlrDd) {
      document.documentElement.dataset.tlrDd = 1;
      document.addEventListener('click', e => { if (!e.target.closest('.tlr-dd')) $$('.tlr-dd[open]').forEach(o => o.open = false); });
    }
    $$('[data-tlr-more-products]').forEach(a => {
      if (a.dataset.ok) return; a.dataset.ok = 1;
      a.addEventListener('click', async e => {
        e.preventDefault(); a.textContent = 'Loading…';
        try {
          const html = await (await fetch(a.href)).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const grid = document.querySelector('[data-tlr-grid]'), next = doc.querySelector('[data-tlr-grid]');
          next.querySelectorAll(':scope > .pc:not(.ed)').forEach(c => grid.appendChild(c));
          const n = grid.querySelectorAll(':scope > .pc:not(.ed)').length, tot = +a.dataset.total;
          document.querySelector('[data-tlr-shown]').textContent = 'Showing ' + n + ' of ' + tot;
          document.querySelector('[data-tlr-bar]').style.width = Math.min(100, n / tot * 100) + '%';
          const nx = doc.querySelector('[data-tlr-more-products]');
          if (nx) { a.href = nx.href; a.textContent = 'Load more'; } else a.remove();
        } catch (err) { location.href = a.href; }
      });
    });
  }
  // ajout rapide : le « + » des petites cartes ouvre une fenêtre (photo, prix, options, quantité)
  const money = c => '£' + (c / 100).toFixed(2);
  let qa;
  function qaShell() {
    if (qa) return qa;
    qa = document.createElement('div');
    qa.className = 'site sC tlr-c tlr-qa'; qa.hidden = true;
    qa.innerHTML = '<div class="tlr-qa__bg" data-qa-close></div><div class="tlr-qa__box" role="dialog" aria-modal="true" aria-label="Quick add">' +
      '<button type="button" class="tlr-qa__x" data-qa-close aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<div class="tlr-qa__body"></div></div>';
    document.body.appendChild(qa);
    qa.addEventListener('click', e => { if (e.target.closest('[data-qa-close]')) qaClose(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !qa.hidden) qaClose(); });
    return qa;
  }
  function qaClose() { qa.hidden = true; document.documentElement.classList.remove('tlr-qa-open'); }
  async function qaOpen(handle) {
    const box = qaShell(), body = box.querySelector('.tlr-qa__body');
    body.innerHTML = '<p class="tlr-qa__wait">Loading…</p>';
    box.hidden = false; document.documentElement.classList.add('tlr-qa-open');
    let p;
    try { p = await (await fetch('/products/' + handle + '.js')).json(); } catch (e) { location.href = '/products/' + handle; return; }
    const sel = (p.variants.find(v => v.available) || p.variants[0]).options.slice();
    let qty = 1;
    const multi = !(p.tags || []).includes('no-multibuy');
    const opts = p.options.filter(o => !(o.values.length === 1 && /default title/i.test(o.values[0])));
    body.innerHTML =
      '<div class="tlr-qa__img"><img alt=""></div><div class="tlr-qa__info">' +
      '<b class="tlr-qa__t"></b><div class="tlr-qa__pr"><span data-qa-price></span><s data-qa-was></s></div>' +
      (multi ? '<p class="tlr-qa__offer">2nd light 20% off, applied in your basket.</p>' : '') +
      opts.map((o, i) => '<div class="tlr-qa__opt"><span class="tlr-qa__ol">' + o.name + '</span><div class="tlr-qa__vals">' +
        o.values.map(v => '<button type="button" class="tlr-qa__v" data-i="' + p.options.indexOf(o) + '" data-v="' + v.replace(/"/g, '&quot;') + '">' + v + '</button>').join('') + '</div></div>').join('') +
      '<div class="tlr-qa__row"><div class="tlr-qa__qty"><button type="button" data-q="-1" aria-label="One less">−</button><span data-qa-q>1</span><button type="button" data-q="1" aria-label="One more">+</button></div>' +
      '<button type="button" class="btn tlr-qa__add" data-qa-add>Add to basket</button></div>' +
      '<a class="tlr-qa__more" href="' + p.url + '">View full details</a><p class="tlr-qa__msg" data-qa-msg hidden></p></div>';
    body.querySelector('.tlr-qa__t').textContent = p.title;
    const cur = () => p.variants.find(v => v.options.every((x, i) => x === sel[i]));
    const draw = () => {
      const v = cur();
      body.querySelectorAll('.tlr-qa__v').forEach(b => {
        const i = +b.dataset.i, test = sel.slice(); test[i] = b.dataset.v;
        const ok = p.variants.some(x => x.available && x.options.every((y, k) => y === test[k]));
        b.classList.toggle('on', sel[i] === b.dataset.v); b.classList.toggle('off', !ok);
      });
      const img = (v && v.featured_image && v.featured_image.src) || p.featured_image;
      body.querySelector('.tlr-qa__img img').src = img + (img.includes('?') ? '&' : '?') + 'width=700';
      body.querySelector('[data-qa-price]').textContent = v ? money(v.price) : '';
      body.querySelector('[data-qa-was]').textContent = v && v.compare_at_price > v.price ? money(v.compare_at_price) : '';
      body.querySelector('[data-qa-q]').textContent = qty;
      const add = body.querySelector('[data-qa-add]');
      add.disabled = !v || !v.available;
      add.textContent = !v || !v.available ? 'Sold out' : 'Add to basket · ' + money(v.price * qty);
    };
    body.querySelectorAll('.tlr-qa__v').forEach(b => b.onclick = () => { sel[+b.dataset.i] = b.dataset.v; draw(); });
    body.querySelectorAll('[data-q]').forEach(b => b.onclick = () => { qty = Math.min(20, Math.max(1, qty + +b.dataset.q)); draw(); });
    body.querySelector('[data-qa-add]').onclick = async () => {
      const v = cur(); if (!v) return;
      const add = body.querySelector('[data-qa-add]'), msg = body.querySelector('[data-qa-msg]');
      add.disabled = true; add.textContent = 'Adding…';
      try {
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] }) });
        const j = await r.json();
        if (!r.ok) throw new Error(j.description || j.message || 'Could not add');
        const cart = await (await fetch('/cart.js')).json();
        $$('[data-tlr-count]').forEach(x => x.textContent = cart.item_count);
        body.querySelector('.tlr-qa__info').innerHTML = '<p class="tlr-qa__ok">Added to your basket</p><b class="tlr-qa__t">' + p.title.replace(/</g, '&lt;') + '</b>' +
          '<div class="tlr-qa__done"><a class="btn" href="/cart">View basket</a><button type="button" class="btn ghost" data-qa-close>Continue shopping</button></div>';
      } catch (e) { msg.hidden = false; msg.textContent = e.message; draw(); }
    };
    draw();
  }
  if (!window.__tlrQaInit) {
    window.__tlrQaInit = 1;
    const go = e => { const b = e.target.closest('.qa[data-tlr-qa]'); if (!b) return; e.preventDefault(); e.stopPropagation(); qaOpen(b.dataset.tlrQa); };
    document.addEventListener('click', go, true);
    document.addEventListener('keydown', e => { if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('.qa[data-tlr-qa]')) go(e); }, true);
  }

  const all = () => { init(); product(); collection(); crossSell(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  // le thème reconstruit la galerie (et parfois les blocs) à chaque variante : on repose compteur et réglages
  const watch = () => {
    const pi = document.querySelector('.product-information');
    if (!pi || pi.dataset.tlrWatch) return; pi.dataset.tlrWatch = 1;
    let t; new MutationObserver(() => { clearTimeout(t); t = setTimeout(() => { product(); crossSell(); }, 120); })
      .observe(pi, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  document.addEventListener('shopify:section:load', all);
  // compteur du panier tenu à jour après un ajout
  document.addEventListener('cart:update', e => { const n = e.detail?.resource?.item_count ?? e.detail?.data?.itemCount;
    if (n != null) $$('[data-tlr-count]').forEach(x => x.textContent = n); });
})();
